import { Artist } from '../types/content';
import { tiAsset } from './tripinkAssets';

/* The seven Trip Ink artists. Slugs match the v5 artist pages at /artist/<slug>
   (full page content lives in pages/tripink/artistInit.ts). Used by /artists and the Book Now artist list. */
export const artists: Artist[] = [
  {
    slug: 'rick-trip',
    name: 'Rick Trip',
    image: tiAsset('w-7118.jpg'),
    roles: ['Owner', 'Lead Tattoo Artist'],
    bio: [
      'Rick Trip owns Trip Ink Tattoo Company and is its lead artist. He is known across the tattoo, art, music and film world.',
      'His specialty is pop-culture color and horror.',
    ],
    instagram: 'ricktrip',
  },
  {
    slug: 'rich-pineda',
    name: 'Rich Pineda',
    image: tiAsset('w-7096.jpg'),
    roles: ['Tattoo Artist'],
    bio: ['Rich Pineda tattoos color and black-and-grey realism, with a focus on horror, movie and music icons.'],
    instagram: 'richpinedaart333',
  },
  {
    slug: 'brian',
    name: 'Brian',
    image: tiAsset('w-7090.jpg'),
    roles: ['Tattoo Artist'],
    bio: ['Brian is Trip Ink’s American traditional specialist. Bold lines, solid color and classic flash.'],
    instagram: 'brian_g_tattoos',
  },
  {
    slug: 'sophia-mae',
    name: 'Sophia Mae',
    image: tiAsset('w-7101.jpg'),
    roles: ['Tattoo Artist', 'Resident Piercer'],
    bio: ['Sophia Mae works in color, anime and illustrative styles. She is also Trip Ink’s resident piercer, by appointment.'],
    instagram: 'sophia_mae113',
    isPiercer: true,
  },
  {
    slug: 'dr-valerio',
    name: 'Dr. Valerio',
    image: tiAsset('w-7108.jpg'),
    roles: ['Tattoo Artist'],
    bio: ['Dr. Valerio has been tattooing for 40 years, across custom pieces, realism, black and grey, color and fine line.'],
    instagram: 'dr.valerio_tattoo',
  },
  {
    slug: 'casso',
    name: 'Casso',
    image: tiAsset('w-7104.jpg'),
    roles: ['Tattoo Artist'],
    bio: ['Casso tattoos black-and-grey realism with a Las Vegas edge.'],
    instagram: 'casso_ink',
  },
  {
    slug: 'chris',
    name: 'Chris',
    image: tiAsset('w-71221.jpg'),
    roles: ['Tattoo Artist', 'Fine Line + Small Pieces'],
    bio: ['Chris handles Trip Ink’s fine-line and small pieces.'],
    instagram: 'chrys.ink.tattoo',
  },
];
